<template>
  <div class="officialWebsiteBottom_box" :class="officialClass">
    <div class="content_box">
      <div class="content_top_box">
        <div class="con_top_left">
          <!-- logo  -->
          <img :src="`${$baseUrl}images/bottom_logo.png`" alt="" class="bottom_logo_box">
          <!-- 链接列表  -->
          <div class="left_list_box">
            <div v-for="(item, index) in contnetList" :key="index + 'link'" class="link_list_box">
              <div class="link_title_box">{{ item.name }}</div>
              <div
                v-for="(it, ind) in item.list"
                :key="ind + 'it'"
                class="link_name_box cursor link_color"
                @click="linkClick(it)"
              >{{
                it.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="con_top_right">
          <div class="right_top_box">
            <!-- 公司信息  -->
            <div v-for="(item, index) in CompanyInformationList" :key="index + 'info'" class="info_box">
              <span>{{ item.name }}: </span>
              <span>{{ item.value }}</span>
            </div>
          </div>
          <!-- 二维码  -->
          <div class="right_bottom_box flex_center" @mouseleave="onMouseLeave()">
            <el-popover
              v-for="(item, index) in codeList"
              :key="index + 'code'"
              placement="top"
              trigger="hover"
              class="code_box cursor"
              popper-class="code_popover_box"
              :open-delay="0"
              :close-delay="0"
              @show="popoverShow(index)"
            >
              <img :src="`${$baseUrl}images/${item.codeUrl}`" alt="" class="popover_caseImg_box">
              <template slot="reference">
                <div class="caseImg_box flex_center" @mouseenter="onMouseEnter(index)">
                  <!-- 只有在鼠标悬停其他元素时才加上 'code_mask_box' 类 -->
                  <img
                    :src="`${$baseUrl}images/${item.codeUrl}`"
                    alt=""
                    class="caseImg"
                    :class="{ 'code_mask_box': activePopoverIndex !== null && activePopoverIndex !== index }"
                  >
                </div>
                <div class="code_name_box">{{ item.name }}</div>
              </template>
            </el-popover>

          </div>
        </div>
      </div>
      <div class="content_bottom_box">
        <span class="move_none">Copyright © 数立方（杭州）信息科技有限公司 All rights reserved.</span>
        <span class="move_display">© 数立方（杭州）信息科技有限公司 All rights reserved.</span>
        <span class="link_color cursor" @click="goPublicInformation('wa')">浙公网安备 33010902002461号</span>
        <span class="link_color cursor" @click="goPublicInformation('ba')">浙ICP备16038333号-4</span>
      </div>
    </div>
  </div>
</template>
<script>
// 官网底部
export default {
  name: 'OfficialWebsiteBottom',

  data() {
    return {
      contnetList: [
        {
          name: '产品',
          list: [
            { name: '履约保函', url: '/businessIntroduction/performance', goType: 'internal' },
            { name: '投标保函', url: '/businessIntroduction/bid', goType: 'internal' },
            { name: '工程数智AI大模型', url: '/businessIntroduction/ai', goType: 'internal' }
          ]
        },
        // {
        //   name: '案例介绍',
        //   list: [
        //     { name: '衢州信用', url: '' },
        //     { name: '衢州信用', url: '' },
        //     { name: '衢州信用', url: '' }
        //   ]
        // },
        {
          name: '关于我们',
          list: [
            { name: '公司介绍', url: '/aboutUs', goType: 'internal' },
            { name: '新闻资讯', url: 'https://bidinfo.datacubr.com', goType: 'external' }
          ]
        }
      ],
      //   公司信息
      CompanyInformationList: [
        { name: '地址', value: '杭州市萧山区电联产融大厦B幢 2302室' },
        { name: '电话', value: '0571-86207767' },
        { name: '邮箱', value: 'kf@datacubr.com' }
      ],
      // 二维码
      codeList: [
        { name: '微信公众号', codeUrl: 'officialAccount.png' },
        { name: '微信视频号', codeUrl: 'videoNumber.png' },
        { name: '浙立保服务号', codeUrl: 'serviceNumber.png' }
      ],
      activePopoverIndex: null,
      enterTimeout: null, // 用来清除快速进入的定时器
      officialClass: ''
    }
  },
  watch: {
    '$route': {
      handler(newValue) {
        const routeData = ['/businessIntroduction/performance', '/businessIntroduction/bid', '/businessIntroduction/ai', '/judicialbusiness', '/aboutUs']
        this.officialClass = routeData.includes(newValue.path) ? 'backFFFF' : ''
      },
      immediate: true
    }
  },
  methods: {
    goPublicInformation(type) {
      let url = ''
      // 网安
      if (type === 'wa') {
        url = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010902002461'
      }
      // 备案号
      if (type === 'ba') {
        url = 'https://beian.miit.gov.cn/#/Integrated/index'
      }
      window.open(url)
    },
    linkClick(item) {
      if (item.goType === 'internal') {
        this.$router.push({ path: item.url, query: { type: item.routeType }})
      }
      if (item.goType === 'external') {
        window.open(item.url)
      }
    },
    // 当鼠标进入某个元素时触发
    onMouseEnter(index) {
      // 如果当前的索引和激活的索引不同，才更新activePopoverIndex
      if (this.activePopoverIndex !== index) {
        // 清除之前的延时操作
        clearTimeout(this.enterTimeout)
        // 设置延时操作，避免鼠标快速经过时频繁更新
        this.enterTimeout = setTimeout(() => {
          this.activePopoverIndex = index
        }, 100) // 延迟100ms更新
      }
    },
    // 当鼠标离开二维码区域时触发
    onMouseLeave() {
      setTimeout(() => {
        this.activePopoverIndex = null
      }, 100)
    },
    // 当某个popover被触发时，更新activePopoverIndex
    popoverShow(index) {
      this.activePopoverIndex = index
    }

  }
}
</script>
<style lang="scss" scoped>
.officialWebsiteBottom_box {
  width: 100%;
  height: 373px;
  background: #F7F8FA;
  font-family: PingFang SC, PingFang SC;

  .content_box {
    width: 1200px;
    margin: auto;

    .content_top_box {
      padding: 60px 0 40px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #E5E6EB;

      .con_top_left {
        display: flex;

        .left_list_box {
          display: flex;
          gap: 60px;
          margin-left: 60px;
          font-weight: 400;
          font-size: 14px;

          .link_title_box {

            color: #1D2129;
            margin-bottom: 16px;
          }

          .link_name_box {

            color: #4E5969;
            margin-bottom: 12px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .con_top_right {
        .right_top_box {

          .info_box {
            height: 22px;
            line-height: 22px;
            font-weight: 400;
            font-size: 14px;
            color: #1D2129;
            margin-bottom: 12px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .right_bottom_box {
          margin-top: 20px;
          gap: 20px;

          .code_box {
            position: relative;
            width: 76px;
            text-align: center;

            .caseImg_box {
              width: 100%;
              height: 76px;
              background: #fff;
              border-radius: 4px;
              border: 1px solid #e5e6eb;

              .caseImg {
                width: 60px;
                height: 60px;
              }

            }

            .code_name_box {
              width: 84px;

              font-weight: 400;
              font-size: 14px;
              color: #4E5969;
              margin-top: 8px;
            }

            .code_mask_box {
              width: 60px;
              height: 60px;
              background: rgba(29, 33, 41, .1);
              opacity: 0.1;
            }
          }
        }
      }

      .bottom_logo_box {
        width: 136px;
        height: 28px;
      }

    }

    .content_bottom_box {
      height: 42px;
      padding-top: 20px;
      text-align: center;

      .link_color {
        color: rgb(22, 127, 255);
      }

      span {
        font-weight: 400;
        font-size: 14px;
        color: #4E5969;
        margin-right: 12px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

  }

}
.backFFFF {
  background: #fff;
}
</style>
<style lang="scss">
.code_popover_box {
  width: 152px;
  height: 144px;
  text-align: center;
  line-height: 144px;
  background: #FFFFFF;
  border-radius: 4px;
  box-sizing: border-box;

  .popover_caseImg_box {
    width: 120px;
    height: 120px;
  }

}

.el-popover {
  padding: 12px 0 !important;
  text-align: center !important;
}
</style>
